module.exports = __webpack_public_path__ + "img/duanwu_ps_03.050cd4db.jpg";